
/**
 * 	Stellt ALLEN Components eine Methode .hitTest( event ) bereit,
 * 	Gibt true zurück, falls ein Event (z.B. click oder touchstart)
 * 	auf dem Element stattgefunden hat.
 *
 */
export default {
	install (Vue, options) {

		Vue.prototype.hitTest = function ( event ) {
		  if (!event) return false;
			var path = event.path || (event.composedPath && event.composedPath());
			if (!path) return false;
			return path.indexOf(this.$el) > -1;
		}

		Vue.prototype.normalizeEvent = function ( event ) {
			var ref = event.touches ? event.touches[0] : event;
			return {
				x: ref.pageX,
				y: ref.pageY,
				tstamp: event.timeStamp,
			}
		}

	}
}
